import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/plan_audit_period_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered).
const PlanAuditPeriodSchema = withDefaults({
  type: 'plan-audit-period',
  fields: [
    { kind: 'attribute', name: 'startMonth' },
    { kind: 'attribute', name: 'endMonth' },
    { kind: 'attribute', name: 'auditMonth' },
    { kind: 'attribute', name: 'position' },
    {
      kind: 'belongsTo',
      name: 'planAuditSchedule',
      type: 'plan-audit-schedule',
      options: { async: false, inverse: 'planAuditPeriods' },
    },
  ],
});

export default PlanAuditPeriodSchema;
